import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmaRenegociacaoModalComponent } from '../../confirma-renegociacao-modal/confirma-renegociacao-modal.component';
import { EnviaLinhaDigitalModalData } from 'src/app/shared/models/envia-linha-digitavel-modal-data';
import { Usuario } from 'src/app/shared/models/usuario.model';

@Component({
  selector: 'app-envia-linha-digitavel-modal',
  templateUrl: './envia-linha-digitavel-modal.component.html',
  styleUrls: ['./envia-linha-digitavel-modal.component.scss']
})
export class EnviaLinhaDigitavelModalComponent implements OnInit {

  usuario: Usuario;

  constructor(
    public dialogRef: MatDialogRef<ConfirmaRenegociacaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EnviaLinhaDigitalModalData,
  ) { }

  ngOnInit(): void {
    this.usuario = new Usuario();

    if (this.data.type === 'EMAIL') { this.usuario.email = this.data.initialValue; }
    if (this.data.type === 'SMS') { this.usuario.telefone = this.data.initialValue; }
  }

  handleSubmit() {
    if (this.data.type === 'EMAIL') { this.usuario.email = this.data.initialValue; }
    if (this.data.type === 'SMS') { this.usuario.telefone = this.data.initialValue; }
    this.dialogRef.close(this.usuario);
  }

}
